import { Animation } from '@ionic/core';
import { EASING_EMPHASIZED_ACCELERATE, DURATION_SHORT_4 } from '../../../../utils/animations';
import { accordionItemOpenAnimation } from './open';

export function accordionItemCloseAnimation(accordionItem: HTMLElement): Animation {
  return accordionItemOpenAnimation(accordionItem)
    .direction('reverse')
    .easing(EASING_EMPHASIZED_ACCELERATE)
    .duration(DURATION_SHORT_4);
}
